//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { ICuralateStore } from '@models/AppState';

export const getBulkScheduleDetails = (state: ICuralateStore) =>
  state.pinterest.postDetails.currentPostDetails.bulkScheduleDetails;
